module.exports = __webpack_public_path__ + "item_3.svg?ed46e00e20c8b5f902673610cc3918e3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item_3.svg
// module id = 26
// module chunks = 0